"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const container_1 = require("./blot/abstract/container");
const format_1 = require("./blot/abstract/format");
const leaf_1 = require("./blot/abstract/leaf");
const scroll_1 = require("./blot/scroll");
const inline_1 = require("./blot/inline");
const block_1 = require("./blot/block");
const embed_1 = require("./blot/embed");
const text_1 = require("./blot/text");
const attributor_1 = require("./attributor/attributor");
const class_1 = require("./attributor/class");
const style_1 = require("./attributor/style");
const store_1 = require("./attributor/store");
const Registry = require("./registry");
let Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;
